var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.01868L21.5938 9.59368C21.5938 9.59368 19.1938 12.3124 16.775 15.8374C14.3563 19.3624 11.75 23.5812 11.75 27.6312C11.75 30.6149 12.9353 33.4763 15.0451 35.5861C17.1548 37.6959 20.0163 38.8812 23 38.8812C25.9837 38.8812 28.8452 37.6959 30.955 35.5861C33.0648 33.4763 34.25 30.6149 34.25 27.6312C34.25 23.5812 31.6438 19.3624 29.225 15.8374C27.7331 13.6704 26.1245 11.586 24.4063 9.59368L23 8.01868ZM23 13.8874C23.825 14.8624 24.575 15.6687 26.15 17.9562C28.4188 21.2562 30.5 25.4562 30.5 27.6312C30.5 31.7937 27.1625 35.1312 23 35.1312C18.8375 35.1312 15.5 31.7937 15.5 27.6312C15.5 25.4562 17.5813 21.2562 19.85 17.9562C21.425 15.6687 22.175 14.8624 23 13.8874Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.6e5a6c68ff82f41b298bfb70590dc264.svg";
export { ForwardRef as ReactComponent };